import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const ProductSetupUITrackConfirmation = {
  name: 'ProductSetupUITrackConfirmation',
  //FIXME: Add correct state check
  // stateCheck: (state: RootAppState) => {
  //   return getSignupDataSkipped(state, Data.TrackEmail);
  // },
  stateCheck: () => false,
  rebuildFlow: (flow, state, dispatch) => {
    const flowSteps = [...flow];
    flowSteps.pop();
    dispatch(setFlow(flowSteps, getFlowSteps().preVerification, getFlowSteps().postVerification, [Step.CrmExperienceLevel, Step.TrackEmail], getFlowSteps().postExistingAccountSelection));
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: Step.TrackEmail
};